var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { findItemByName } from './find-item-by-name';
import { getIsMenuItemShown } from './get-is-menu-item-shown';
export var getResultMappedMenu = function (_a) {
    var responseMenuData = _a.responseMenuData, injectedProducts = _a.injectedProducts, additionalProductsData = _a.additionalProductsData, router = _a.router, fullFlattenMenuProductsList = _a.fullFlattenMenuProductsList;
    return responseMenuData.reduce(function (acc, item) {
        var _a;
        var responseMenuItem = __assign({}, item);
        // для отображения пунктов меню, если есть прямая или относительная ссылка на переход
        if (responseMenuItem.relativeURL || responseMenuItem.absoluteURL) {
            return __spreadArray(__spreadArray([], acc, true), [responseMenuItem], false);
        }
        // элемент из Полного плоского списка меню
        var productConfigInFullList = findItemByName({
            items: fullFlattenMenuProductsList,
            nameToFind: responseMenuItem.name,
        });
        // элемент из списка меню загруженных элементов
        var productConfigInInjectedItems = findItemByName({
            items: injectedProducts,
            nameToFind: responseMenuItem.name,
        });
        // элемент из списка дополнительных настроек для меню
        var additionalProductConfig = findItemByName({
            items: additionalProductsData,
            nameToFind: responseMenuItem.name,
        });
        // выставляем дефолтный роут если есть
        if (additionalProductConfig.defaultRoute &&
            productConfigInInjectedItems.loaded) {
            router.setOption('defaultRoute', productConfigInInjectedItems.routeName);
        }
        // проверяем показывать ли элемент
        var isMenuItemShown = getIsMenuItemShown({
            additionalProductConfig: additionalProductConfig,
            productConfigInFullList: productConfigInFullList,
            productConfigInInjectedItems: productConfigInInjectedItems,
            responseMenuItem: responseMenuItem,
        });
        if (!isMenuItemShown) {
            return acc;
        }
        // проверяем на вложенность
        if (responseMenuItem.nextLevelItems) {
            if (responseMenuItem.nextLevelItems.length === 0) {
                return acc;
            }
            responseMenuItem.nextLevelItems = getResultMappedMenu({
                responseMenuData: responseMenuItem.nextLevelItems,
                injectedProducts: injectedProducts,
                additionalProductsData: additionalProductsData,
                router: router,
                fullFlattenMenuProductsList: fullFlattenMenuProductsList,
            });
            responseMenuItem.nextLevelItems;
            return __spreadArray(__spreadArray([], acc, true), [responseMenuItem], false);
        }
        // проверка наличия существования конфига в элементе из данных бекенда
        var _b = (_a = productConfigInFullList === null || productConfigInFullList === void 0 ? void 0 : productConfigInFullList.config) !== null && _a !== void 0 ? _a : {}, routePath = _b.routePath, routeName = _b.routeName;
        var routerParams = {
            url: routePath || productConfigInInjectedItems.path,
            routeName: routeName || productConfigInInjectedItems.routeName,
        };
        var mappedMenuItem = __assign(__assign({}, responseMenuItem), { routeName: routerParams.routeName, url: routerParams.url, separatorLineAfter: additionalProductConfig.separatorLineAfter, customClickType: additionalProductConfig.customClickType, setUserName: additionalProductConfig.setUserName, loaded: productConfigInInjectedItems.loaded, 
            // событие которое будет отдельно обработано ui модулем
            eventName: responseMenuItem.eventName || additionalProductConfig.eventName, eventParams: additionalProductConfig.eventParams, 
            // нужно для уточнения доп стилистики пункта
            buttonVariant: responseMenuItem.buttonVariant ||
                additionalProductConfig.buttonVariant });
        return __spreadArray(__spreadArray([], acc, true), [mappedMenuItem], false);
    }, []);
};
